import {Component, Inject} from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AngularFireAuth} from '@angular/fire/auth';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as firebase from 'firebase';

@Component({
    selector: 'app-modal-login',
    templateUrl: 'login.component.resetDialog.html',
    styleUrls: ['login.component.scss']
})

export class DialogLoginProblemsComponent {
    resetPasswordForm: FormGroup = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
    });

    changePasswordForm: FormGroup = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        oldPassword: ['', Validators.required],
        newPassword: ['', Validators.required]
    });

  changeMailForm: FormGroup = this.fb.group({
    newMail: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required]
  });

    errorMessage = '';
    email: string = firebase.auth().currentUser ? firebase.auth().currentUser.email : '';

    constructor(
        private db: AngularFirestore,
        private afAuth: AngularFireAuth,
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
      console.log('ddd', this.data.type);
    }

    onPasswordReset = () => {
        const email = this.resetPasswordForm.controls.email.value;

        this.afAuth.auth.sendPasswordResetEmail(email).then(
            () => {
                this.dialogRef.close();
            },
            err => {
                this.errorMessage = err.message;
            }
        );
    }

    onChangePassword = async () => {
        const oldPassword = this.changePasswordForm.controls.oldPassword.value;
        const newPassword = this.changePasswordForm.controls.newPassword.value;

        try {
            const currentUser = await this.afAuth.auth.signInWithEmailAndPassword(this.email, oldPassword);
            currentUser.user.updatePassword(newPassword)
                .then(res => {
                    this.dialogRef.close();
                }, err => {
                    console.log(err);
                    this.errorMessage = err.message;
                });
        } catch (error) {
            this.errorMessage = error.message;
        }
    }

  onChangeMail = async () => {
    const newMail = this.changeMailForm.controls.newMail.value;
    const password = this.changeMailForm.controls.password.value;

    console.log(password + ' ' + newMail)
    try {
      const currentUser = await this.afAuth.auth.signInWithEmailAndPassword(this.email, password);
      currentUser.user.updateEmail(newMail)
        .then(res => {
          this.dialogRef.close();
        }, err => {
          console.log(err);
          this.errorMessage = err.message;
        });
    } catch (error) {
      this.errorMessage = error.message;
    }
  }
}
